import { resetModalContent, setModalContent } from '../../Slice';
import Store from '../../Store';

export const resetAlertModal = () => {
   Store.dispatch(resetModalContent());
};

export const setAlertModal = obj => {
   Store.dispatch(setModalContent(obj));
};
